import './CommonMessage.css';
import { jsx as o, Fragment as m, jsxs as l } from "react/jsx-runtime";
import C from "clsx";
import { forwardRef as f } from "react";
import { COMMON_MESSAGE_DTI as E } from "./CommonMessage.consts.mjs";
import { ECommonMessageType as t, ECommonMessageSize as s } from "./CommonMessage.types.mjs";
const h = "_wrapper_99w1x_1", S = "_medium_99w1x_24", g = "_small_99w1x_28", I = "_xsmall_99w1x_32", O = "_attention_99w1x_37", T = "_error_99w1x_42", v = "_notice_99w1x_47", A = "_success_99w1x_52", y = "_info_99w1x_57", L = "_help_99w1x_62", R = "_iconWrapper_99w1x_67", D = "_contentWrapper_99w1x_76", F = "_accentWrapper_99w1x_79", e = {
  wrapper: h,
  medium: S,
  small: g,
  xsmall: I,
  attention: O,
  error: T,
  notice: v,
  success: A,
  info: y,
  help: L,
  iconWrapper: R,
  contentWrapper: D,
  accentWrapper: F
}, P = f((d, x) => {
  const {
    type: r = t.INFO,
    size: a = s.MEDIUM,
    dti: n = E,
    icon: c,
    accent: p,
    content: w,
    className: i,
    children: _,
    divProps: W,
    contentWrapperProps: M,
    iconWrapperProps: N
  } = d, u = C({
    [e.wrapper]: !0,
    // Sizes
    [e.medium]: a === s.MEDIUM,
    [e.small]: a === s.SMALL,
    [e.xsmall]: a === s.XSMALL,
    // Types
    [e.error]: r === t.ERROR,
    [e.attention]: r === t.ATTENTION,
    [e.notice]: r === t.NOTICE,
    [e.success]: r === t.SUCCESS,
    [e.info]: r === t.INFO,
    // Custom classes
    [String(i)]: !!i
  });
  return /* @__PURE__ */ o("div", { ...W, ref: x, "data-testid": n, className: u, children: _ !== void 0 ? /* @__PURE__ */ o(m, { children: _ }) : /* @__PURE__ */ l(m, { children: [
    c !== void 0 ? /* @__PURE__ */ o("div", { ...N, "data-testid": `${n}__iconWrapper`, className: e.iconWrapper, children: c }) : null,
    /* @__PURE__ */ l("p", { ...M, "data-testid": `${n}Content`, className: e.contentWrapper, children: [
      p ? /* @__PURE__ */ o("strong", { "data-testid": `${n}Content__Accent`, className: e.accentWrapper, children: p }) : null,
      w
    ] })
  ] }) });
});
P.displayName = "CommonMessage";
export {
  P as C
};
//# sourceMappingURL=CommonMessage-O3X6ahzz.js.map
